var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22519 5.34275C4.27981 5.40441 4.3469 5.45377 4.42202 5.48757C4.49713 5.52138 4.57857 5.53886 4.66094 5.53886C4.74331 5.53886 4.82475 5.52138 4.89986 5.48757C4.97498 5.45377 5.04207 5.40441 5.09669 5.34275L8.46427 1.554C8.79911 1.17833 8.53194 0.583332 8.02852 0.583332H1.29336C0.790524 0.583332 0.523357 1.17833 0.857607 1.55458L4.22519 5.34275Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sortDESC.f50b822f74ac3e073926e03b60372e78.svg";
export { ForwardRef as ReactComponent };